  document.addEventListener('DOMContentLoaded', function () {
    // Abrir modal al hacer clic en el botón
    const modalTriggers = document.querySelectorAll('.modal-trigger');
    modalTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        const modalId = this.getAttribute('data-modal-id');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.style.display = 'flex';
          setTimeout(function () {
            modal.classList.add('active');
          }, 10);
          // Prevenir que el scroll de la página funcione cuando el modal está abierto
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Cerrar modal al hacer clic en la X
    const closeButtons = document.querySelectorAll('.close-modal');
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const modalId = this.getAttribute('data-modal-id');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.remove('active');
          setTimeout(function () {
            modal.style.display = 'none';
            // Restaurar el scroll cuando se cierra el modal
            document.body.style.overflow = '';
          }, 300);
        }
      });
    });

    // Cerrar modal al hacer clic fuera del contenido
    const modals = document.querySelectorAll('.banner-modal');
    modals.forEach(function (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          modal.classList.remove('active');
          setTimeout(function () {
            modal.style.display = 'none';
            // Restaurar el scroll cuando se cierra el modal
            document.body.style.overflow = '';
          }, 300);
        }
      });
    });

    // Cerrar modal con tecla Escape
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        const activeModals = document.querySelectorAll('.banner-modal.active');
        activeModals.forEach(function (modal) {
          modal.classList.remove('active');
          setTimeout(function () {
            modal.style.display = 'none';
            document.body.style.overflow = '';
          }, 300);
        });
      }
    });
  });
